import { customElement, FASTElement } from '@genesislcap/web-core';
import { CashProDataTemplate as template } from './cash-pro-data.template';
import { CashProDataStyles as styles } from './cash-pro-data.styles';

const name = 'cash-pro-data';

@customElement({
  name,
  template,
  styles
})
export class CashProData extends FASTElement {
}
